module.exports = __webpack_public_path__ + "img/10.d4947112.jpg";